import api from './index'

const resource = 'instances'

export default {
  getInstance () {
    const url = resource + '/get_instance'
    return api.get(url)
  },
  updateValidateMatrix () {
    const url = resource + '/update_validate_matrix'
    return api.put(url)
  },
}
